<template>
  <div style="padding: 10px">
    <v-app-bar flat color="white">
      <v-spacer/>
      <v-app-bar-title class="centered-title">{{$t("EquipmentsTable.devices")}} {{ pageNumber }}</v-app-bar-title>
      <v-progress-circular
        class="loading-icon"
        v-if="loading"
        indeterminate
        size="20"
        width="3"
        color="#0098E1"
      ></v-progress-circular>
      <v-spacer/>
    </v-app-bar>
    <v-data-table
      :headers="headers"
      :items="dataTable"
      hide-default-footer
      class="text-center table-content"
    >
      <template v-slot:items="props" v-if="!loading">
        <td class="text-center">{{ props.item.deviceName }}</td>
        <td class="text-center">{{ props.item.plotName }}</td>
        <td class="text-center">{{ props.item.orientation }}</td>
        <td class="text-center">{{ props.item.currentState }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {makeFetchQueryRequest} from '../../lib/helpers'
import {auth} from '../../plugins/firebase'
export default {
  props: {
    limit: {
      type: String,
      default: ''
    },
    pageNumber: {
      type: String,
      default: ''
    },
    timeRange: {
      type: Object,
      default: {}
    },
    organizationId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: [],
      headers: [
        {
          text: this.$t('EquipmentsTable.device'),
          align: 'center',
          sortable: true,
          value: 'deviceName'
        },
        { text: this.$t('EquipmentsTable.currentLot'), align: 'center', value: 'plotName' },
        { text: this.$t('EquipmentsTable.orientation'), align: 'center', value: 'orientation' },
        { text: this.$t('EquipmentsTable.state'), align: 'center', value: 'currentState' }
      ],
      dataTable: [],
      loading: false
    }
  },
  created () {
    this.getDataTable(this.timeRange.from, this.timeRange.to, this.organizationId)
  },
  watch: {
    timeRange (value) {
      this.getDataTable(value.from, value.to, this.organizationId)
    },
    organizationId (value) {
      this.getDataTable(this.timeRange.from, this.timeRange.to, value)
    }
  },
  computed: {},
  methods: {
    async getDataTable (fromDate, toDate, organizationId) {
      if (!organizationId || (organizationId && organizationId.length === 0)) {
        organizationId = 'PONCE'
      }
      if (fromDate && toDate) {
        this.loading = true
        const fetchBody = {
          type: 'organizationStateChange',
          data: {
            organizationId,
            fromDate: fromDate.getTime(),
            toDate: toDate.getTime()
          }
        }
        try {
          const res = await makeFetchQueryRequest(fetchBody, auth.currentUser)
          let uniqueEquipments = []
          res.forEach((elem) => {
            if (!uniqueEquipments.find(equipment => equipment.deviceName === elem.deviceName)) {
              uniqueEquipments.push(elem)
            }
          })
          uniqueEquipments = this.$ponceConfig.sortArrayByName(uniqueEquipments)
          uniqueEquipments = uniqueEquipments.slice((this.pageNumber - 1) * this.limit, (this.pageNumber) * this.limit)
          uniqueEquipments.forEach((elem) => {
            const current = elem.currentState
            if (current === 0) {
              elem.currentState = this.$t('EquipmentsTable.disconnected')
            } else if (current === 1) {
              elem.currentState = this.$t('EquipmentsTable.off')
            } else if (current === 6) {
              elem.currentState = this.$t('EquipmentsTable.irrigating')
            } else if (current === 7) {
              elem.currentState = this.$t('EquipmentsTable.movement')
            } else {
              elem.currentState = '-'
            }
          })
          this.dataTable = uniqueEquipments
        } catch (error) {
          console.log(error.message)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// EquipmentsTable.vue?379def9e